import { WidgetType } from 'shared/widgets/utils';

import { manifestLocales } from './manifest.locales';
import AudioEn from './resources/en/audio.svg';
import AudioHe from './resources/he/audio.svg';
import { AudioObject } from '@/icons/AudioObject';
import { ManifestType } from '@/types/ManifestType';
import { createNewAudioData } from '@/widgets/Audio/create';

export const Manifest: ManifestType = {
  name: WidgetType.Audio,
  previewGroups: [
    {
      id: 'audio',
      divider: {
        icon: AudioObject,
        title: 'audio'
      },
      previews: [
        {
          name: 'audioPreview',
          previewImage: {
            paths: {
              en: AudioEn,
              he: AudioHe
            },
            size: {
              width: 285,
              height: 140
            },
            alt: { ...manifestLocales.audio.previewImageAlt }
          },
          dimensions: {
            width: 75,
            height: 75
          },
          initializeProps: () => createNewAudioData()
        }
      ]
    }
  ],
  additionalData: {
    maxFileSizeBytes: 3_072_000,
    acceptFileType: ['audio/x-wav', 'audio/mpeg', 'audio/x-ms-wma'],
    maxFiles: 1,
    constraints: {
      minHeight: 75,
      minWidth: 75
    }
  }
};
